<template>
  <v-container>
    <v-card
      outlined
      class="pa-3 mb-3"
    >
      <v-row dense>
        <v-col
          cols="12"
          md="5"
        >
          <v-text-field
            v-model="filter"
            outlined
            dense
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            label="ຄົ້ນຫາ: ຊື່, ເບີໂທ, CUS_, ເລກບິນ (ID#)"
            @keyup.enter="load(1)"
            @click:clear="clearFilter"
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
        >
          <v-text-field
            v-model="month"
            type="month"
            outlined
            dense
            hide-details
            clearable
            label="ເດືອນບິນ"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="d-flex align-center flex-wrap"
        >
          <v-btn
            color="primary"
            depressed
            class="mr-2 mb-1"
            @click="load(1)"
          >
            <v-icon left>
              mdi-magnify
            </v-icon>
            ຄົ້ນຫາ
          </v-btn>
          <v-btn
            color="success"
            depressed
            class="mr-2 mb-1"
            @click="importDialog = true"
          >
            <v-icon left>
              mdi-file-import
            </v-icon>
            Import Excel
          </v-btn>
          <v-btn
            text
            color="success"
            class="mb-1"
            :loading="downloading"
            @click="downloadTemplate"
          >
            <v-icon left>
              mdi-microsoft-excel
            </v-icon>
            ດາວໂຫລດແບບຟອມ
          </v-btn>
        </v-col>
      </v-row>
      <div class="text-caption grey--text mt-2">
        ສະແດງສະເພາະບິນລູກຄ້າສາຍບ້ານ. ບິນ "ຈ່າຍແລ້ວ ກວດສອບສຳເລັດ" ຫຼື "ຈ່າຍແລ້ວ ລໍຖ້າກວດສອບ" ເລືອກລຶບບໍ່ໄດ້.
        ຄຳຂໍຕ້ອງຜ່ານການອະນຸມັດ 3 ຂັ້ນ (ຄົນລະຄົນ) ຈຶ່ງຈະລຶບ; ຕອນລຶບ ການຈ່າຍ QR ທີ່ຍັງລໍຖ້າຂອງບິນນັ້ນຈະຖືກຍົກເລີກ.
      </div>
    </v-card>

    <v-card
      v-if="selected.length"
      outlined
      class="pa-3 mb-3"
    >
      <div class="mb-2 font-weight-medium">
        ບິນທີ່ເລືອກ {{ selected.length }} ໃບ · ລວມ {{ money(selectedTotal) }} ກີບ
      </div>
      <v-chip
        v-for="b in selected"
        :key="b.id"
        small
        close
        class="mr-1 mb-1"
        @click:close="unselect(b)"
      >
        {{ b.bill_number }} · {{ b.name }} · {{ money(b.total) }}
      </v-chip>
      <v-textarea
        v-model="reason"
        outlined
        dense
        rows="2"
        auto-grow
        class="mt-2"
        label="ເຫດຜົນທີ່ຂໍລຶບ *"
        :error-messages="reasonError"
        @input="reasonError = ''"
      />
      <div class="d-flex">
        <v-spacer />
        <v-btn
          color="error"
          depressed
          :loading="sending"
          @click="openConfirm"
        >
          <v-icon left>
            mdi-send
          </v-icon>
          ສົ່ງຂໍລຶບ {{ selected.length }} ໃບ
        </v-btn>
      </div>
    </v-card>

    <v-card outlined>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="bills"
        :loading="loading"
        item-key="id"
        show-select
        selectable-key="selectable"
        :item-class="(item) => (item.selectable ? '' : 'grey lighten-4')"
        hide-default-footer
        disable-pagination
        disable-sort
        no-data-text="ບໍ່ພົບບິນ"
      >
        <template v-slot:[`item.bill_number`]="{ item }">
          <div>{{ item.bill_number }}</div>
          <div class="text-caption grey--text">
            {{ item.content }}
          </div>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div>{{ item.name }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_code }} · {{ item.phone }}
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ money(item.total) }}
        </template>
        <template v-slot:[`item.status_la`]="{ item }">
          <v-chip
            x-small
            :color="getBgColor(item.status)"
            dark
          >
            {{ item.status_la }}
          </v-chip>
          <div
            v-if="item.blocked_reason"
            class="text-caption red--text"
          >
            {{ item.blocked_reason }}
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-if="pagination.total_pages > 1"
        v-model="page"
        :length="pagination.total_pages"
        :total-visible="7"
        class="my-2"
        @input="load"
      />
    </v-card>

    <h3 class="mt-6 mb-2">
      ຄຳຂໍຂອງຂ້ອຍ (ລໍຖ້າ / ຖືກປະຕິເສດ)
    </h3>
    <v-card outlined>
      <v-data-table
        :headers="mineHeaders"
        :items="mine"
        :items-per-page="20"
        no-data-text="ບໍ່ມີຄຳຂໍທີ່ຄ້າງ"
      >
        <template v-slot:[`item.bill_number`]="{ item }">
          <div>{{ item.bill_number }} · {{ money(item.total) }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_name }} · {{ item.customer_code }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            x-small
            :color="item.status === 'rejected' ? 'red lighten-5' : 'amber lighten-5'"
            :text-color="item.status === 'rejected' ? 'red darken-2' : 'amber darken-4'"
          >
            {{ item.status === 'rejected' ? `ຖືກປະຕິເສດ (ຂັ້ນທີ ${item.step})` : `ລໍຖ້າອະນຸມັດ ຂັ້ນທີ ${item.step}/3` }}
          </v-chip>
          <div
            v-if="item.reject_reason"
            class="text-caption red--text"
          >
            {{ item.reject_reason }}
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="confirm"
      max-width="460"
    >
      <v-card>
        <v-card-title>ຢືນຢັນສົ່ງຂໍລຶບບິນ</v-card-title>
        <v-card-text>
          ສົ່ງຄຳຂໍລຶບບິນສາຍບ້ານ {{ selected.length }} ໃບ (ລວມ {{ money(selectedTotal) }} ກີບ)?
          ບິນຈະຖືກລຶບ ເມື່ອຜ່ານການອະນຸມັດຄົບ 3 ຂັ້ນ.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="confirm = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="error"
            depressed
            :loading="sending"
            @click="send"
          >
            ສົ່ງຂໍລຶບ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <excel-import-dialog
      v-model="importDialog"
      api="home-bill-delete-request"
      title="Import ບິນທີ່ຈະຂໍລຶບ (Excel)"
      @download-template="downloadTemplate"
      @imported="afterImport"
    >
      ຖັນ A: ເລກບິນ (ID#00123 ຫຼື 123), ຖັນ B: ເບີໂທລູກຄ້າ (ຕ້ອງກົງກັບລູກຄ້າຂອງບິນ), ຖັນ C: ເຫດຜົນ.
      <b>ຕ້ອງໃສ່ຄົບທັງ 3 ຖັນ.</b>
    </excel-import-dialog>
  </v-container>
</template>

<script>
import { getBgColor } from '@/Helpers/BillingStatus';
import ExcelImportDialog from '@/views/threeStep/ExcelImportDialog.vue';
import { money } from '@/views/threeStep/cells';

export default {
  name: 'HomeBillDeleteRequest',
  components: { ExcelImportDialog },
  title() {
    return 'Vientiane Waste Co-Dev|Home Bill Delete Request';
  },
  data() {
    return {
      filter: '',
      month: '',
      bills: [],
      loading: false,
      page: 1,
      pagination: {},
      selected: [],
      reason: '',
      reasonError: '',
      confirm: false,
      sending: false,
      mine: [],
      importDialog: false,
      downloading: false,
      headers: [
        { text: 'ເລກບິນ', value: 'bill_number' },
        { text: 'ລູກຄ້າ', value: 'name' },
        { text: 'ເດືອນບິນ', value: 'bill_month' },
        { text: 'ຍອດເງິນ', value: 'total', align: 'end' },
        { text: 'ສະຖານະ', value: 'status_la' },
      ],
      mineHeaders: [
        { text: 'ເລກຄຳຂໍ', value: 'id' },
        { text: 'ບິນ', value: 'bill_number', sortable: false },
        { text: 'ເຫດຜົນ', value: 'reason', sortable: false },
        { text: 'ວັນທີສົ່ງ', value: 'created_at' },
        { text: 'ສະຖານະ', value: 'status' },
      ],
    };
  },
  computed: {
    selectedTotal() {
      return this.selected.reduce((sum, b) => sum + Number(b.total || 0), 0);
    },
  },
  created() {
    this.load(1);
    this.loadMine();
  },
  methods: {
    getBgColor,
    money,
    unselect(b) {
      this.selected = this.selected.filter((s) => s.id !== b.id);
    },
    clearFilter() {
      this.filter = '';
      this.load(1);
    },
    load(page) {
      this.page = page || 1;
      this.loading = true;
      this.$axios
        .get('home-bill-delete-request/bills', {
          params: {
            page: this.page, per_page: 50, filter: this.filter || undefined, month: this.month || undefined,
          },
        })
        .then((res) => {
          this.bills = (res.data.data.data || []).map((b) => ({ ...b, selectable: !b.blocked_reason }));
          this.pagination = res.data.data.pagination || {};
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.loading = false;
        });
    },
    loadMine() {
      this.$axios
        .get('home-bill-delete-request', { params: { per_page: 100 } })
        .then((res) => {
          this.mine = res.data.data.data || [];
        })
        .catch(() => {});
    },
    afterImport() {
      this.load(1);
      this.loadMine();
    },
    openConfirm() {
      if (!this.reason || !this.reason.trim()) {
        this.reasonError = 'ກະລຸນາໃສ່ເຫດຜົນ';
        return;
      }
      this.confirm = true;
    },
    send() {
      this.sending = true;
      this.$axios
        .post('home-bill-delete-request', { billing_ids: this.selected.map((b) => b.id), reason: this.reason.trim() })
        .then(() => {
          this.toast('success', 'ສົ່ງຄຳຂໍລຶບບິນແລ້ວ, ລໍຖ້າອະນຸມັດຂັ້ນທີ 1');
          this.selected = [];
          this.reason = '';
          this.load(this.page);
          this.loadMine();
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.sending = false;
          this.confirm = false;
        });
    },
    downloadTemplate() {
      this.downloading = true;
      this.$axios
        .get('home-bill-delete-request/template', { responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'ແບບຟອມ_ລຶບບິນສາຍບ້ານ.xlsx';
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => this.toast('error', 'ດາວໂຫລດບໍ່ສຳເລັດ'))
        .finally(() => {
          this.downloading = false;
        });
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || 'Something went wrong';
    },
    toast(color, msg) {
      this.$store.commit('Toast_State', { value: true, color, msg });
    },
  },
};
</script>
